import { PayloadRiskReportResults } from "app/area/case-report/risk-listing/types-store";
import { ComplexValue, FavouriteLayoutModel } from "app/types-shared";

export const ACTION = {
  REQUEST_RISK_REPORT_RESULTS: 'RISK_REPORT:REQUEST_RISK_RESULTS',
  REPLACE_RISK_REPORT_RESULTS: 'RISK_REPORT:REPLACE_RISK_RESULTS',
  ADD_INSTANCE: 'RISK_REPORT:ADD_INSTANCE',
  CLEAR_INSTANCE: 'RISK_REPORT:CLEAR_INSTANCE',
  FAIL_EXECUTE_FAVOURITE: 'RISK_REPORT:FAIL_EXECUTE_FAVOURITE',
  REQUEST_OPTIONS_DRILL_DOWN_TO: 'RISK_REPORT:REQUEST_OPTIONS_DRILL_DOWN_TO',
  RESPONSE_OPTIONS_DRILL_DOWN_TO: 'RISK_REPORT:RESPONSE_OPTIONS_DRILL_DOWN_TO'
};

export class ReplaceRiskReportResults {
  public type: string = ACTION.REPLACE_RISK_REPORT_RESULTS;

  constructor(
    public instanceKey: string,
    public riskReportResults: PayloadRiskReportResults,
    public layoutModel: FavouriteLayoutModel,
    public requestId: number
  ) { }
}

export class RequestRiskReportResults {
  public type: string = ACTION.REQUEST_RISK_REPORT_RESULTS;

  constructor(public instanceKey: string) { }
}

export class AddInstance {
  public type: string = ACTION.ADD_INSTANCE;

  constructor(public instanceKey: string) { }
}

export class ClearInstance {
  public type: string = ACTION.CLEAR_INSTANCE;

  constructor(public instanceKey: string) { }
}

export class FailExecuteFavourite {
  public type: string = ACTION.FAIL_EXECUTE_FAVOURITE;

  constructor(
    public instanceKey: string,
    public errorsExecuteFailed: string[]
  ) { }
}

export class RequestOptionsDrillDownTo {
  public type: string = ACTION.REQUEST_OPTIONS_DRILL_DOWN_TO;
  constructor(public instanceKey: string) {}
}

export class ResponseOptionsDrillDownTo {
  public type: string = ACTION.RESPONSE_OPTIONS_DRILL_DOWN_TO;
  constructor(public instanceKey: string, public data: ComplexValue<number>[]) {}
}
